























































import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { ApiResponse } from '@/components/types';
import { REGISTER_ACCOUNTING } from '@/modules/employee/store';
import { createAccounting } from '@/modules/employee/admin/models';
import { RegisterAccounting } from '@/modules/employee/types';
import SalutationSelect from '@/modules/conservatorship/components/SalutationSelect.vue';

const Employee = namespace('employee');

@Component({
  components: {
    SalutationSelect
  }
})
export default class AccountingForm extends Vue {
  @Employee.Action(REGISTER_ACCOUNTING) register!: (params: RegisterAccounting) => Promise<ApiResponse>;

  error: any = null;
  loading: boolean = false;

  value: RegisterAccounting = createAccounting();

  reset(observer?: any) {
    this.error = null;
    this.value = createAccounting();

    observer && observer.reset();
  }

  cancel(observer?: any) {
    this.reset(observer);
    this.$emit('cancel');
  }

  back(observer: any) {
    this.reset(observer);
    this.$emit('back');
  }

  save() {
    this.error = null;

    return this.register(this.value);
  }
}
